var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[(_vm.post.gds_featured_image)?_c('Figure',{attrs:{"data":_vm.post.gds_featured_image}}):_vm._e(),_c('Title',{attrs:{"data":{ value: _vm.post.title.rendered }}}),_vm._v(" "+_vm._s(_vm.post)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }